import { IconButton, Tooltip } from "@mui/material";

import BadgeIcon from "@mui/icons-material/Badge";

import { PersistedRecordingDownloadStatus } from "types/PersistedRecordingDownloadStatus";
import { useAppSelector } from "app/hooks";
import { reIdSelectors } from "./store/selectors";
import { EntityId } from "@reduxjs/toolkit";

export interface ReIdPersistedRecordingButtonProps {
    persistedRecordingId: EntityId;
    persistedRecordingState: PersistedRecordingDownloadStatus;
    reIdViewModeIsActive: boolean;
    onClick: (isToggledOn: boolean) => void;
}

export function ReIdPersistedRecordingButton(
    props: ReIdPersistedRecordingButtonProps,
) {
    const recordingNotCompleted =
        props.persistedRecordingState !==
        PersistedRecordingDownloadStatus.Completed;

    const hasObjectDetectionFramesForPersistedRecording = useAppSelector(
        (state) =>
            reIdSelectors.selectHasObjectDetectionFramesForPersistedRecording(
                state,
                props.persistedRecordingId,
            ),
    );

    const disableReIdControl =
        recordingNotCompleted || !hasObjectDetectionFramesForPersistedRecording;

    return (
        <Tooltip
            title={
                props.reIdViewModeIsActive
                    ? "Hide Identified Objects"
                    : "Show Identified Objects"
            }
        >
            <IconButton
                disabled={disableReIdControl}
                onClick={() => {
                    props.onClick(!props.reIdViewModeIsActive);
                }}
            >
                <BadgeIcon
                    color={
                        disableReIdControl
                            ? "disabled"
                            : props.reIdViewModeIsActive
                              ? "primary"
                              : "action"
                    }
                    sx={{ opacity: recordingNotCompleted ? 0.3 : 1 }}
                />
            </IconButton>
        </Tooltip>
    );
}
